/* Soften PDP — Custom product page interactions */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------------------------------------------------------
   * Gallery: swipeable carousel with thumbnail + arrow navigation
   * ------------------------------------------------------------- */
  function initGallery(root) {
    const main = root.querySelector('[data-soften-gallery-main]');
    const track = root.querySelector('[data-soften-gallery-track]');
    const slides = track ? Array.from(track.querySelectorAll('.soften-gallery__slide')) : [];
    const thumbs = Array.from(root.querySelectorAll('[data-soften-gallery-thumb]'));
    const prevBtn = root.querySelector('[data-soften-gallery-prev]');
    const nextBtn = root.querySelector('[data-soften-gallery-next]');
    if (!main || !track || !slides.length) return;

    function setActive(index) {
      const safe = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach((slide, i) => {
        slide.setAttribute('data-active', i === safe ? 'true' : 'false');
      });
      thumbs.forEach((thumb) => {
        const idx = parseInt(thumb.getAttribute('data-index'), 10);
        thumb.setAttribute('aria-current', idx === safe ? 'true' : 'false');
      });
      if (prevBtn) prevBtn.disabled = safe === 0;
      if (nextBtn) nextBtn.disabled = safe === slides.length - 1;
    }

    function scrollToIndex(index, behavior) {
      const safe = Math.max(0, Math.min(slides.length - 1, index));
      const slide = slides[safe];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'smooth' });
      setActive(safe);
    }

    function currentIndex() {
      const center = track.scrollLeft + track.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      slides.forEach((slide, i) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const dist = Math.abs(center - slideCenter);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const idx = parseInt(thumb.getAttribute('data-index'), 10);
        scrollToIndex(idx);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => scrollToIndex(currentIndex() - 1));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => scrollToIndex(currentIndex() + 1));
    }

    let scrollRaf;
    track.addEventListener('scroll', () => {
      if (scrollRaf) cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(() => setActive(currentIndex()));
    }, { passive: true });

    setActive(0);
  }

  /* ---------------------------------------------------------------
   * Variant pickers: update selected variant + price + cart form
   * ------------------------------------------------------------- */
  function initVariantForm(form) {
    if (!form) return;

    // Only the inputs sit inside the <form>; the price row, gallery and the rest
    // of the UI are siblings elsewhere in the section. Queries therefore run
    // against the section root, falling back to document so the sticky bar —
    // which lives outside the section entirely — is still reachable.
    const root = form.closest('[data-soften-form-root]') || form.parentElement || document;

    const productData = (() => {
      try {
        return JSON.parse(form.querySelector('[data-soften-product-json]').textContent);
      } catch (e) {
        return null;
      }
    })();
    if (!productData) return;

    function findVariant() {
      const selected = [];
      const optionInputs = form.querySelectorAll('[data-soften-option]');
      const grouped = {};
      optionInputs.forEach((input) => {
        if (input.type === 'radio' && !input.checked) return;
        const pos = parseInt(input.getAttribute('data-soften-option'), 10);
        grouped[pos] = input.value;
      });

      const totalOptions = productData.options.length;
      for (let i = 1; i <= totalOptions; i++) {
        selected.push(grouped[i]);
      }

      return productData.variants.find((v) => {
        return v.options.every((opt, i) => opt === selected[i]);
      });
    }

    function formatMoney(cents) {
  const amount = (cents / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return '<span class="money">$' + amount + '</span>';
}

    // Client-side twin of Liquid's `| handle` filter. Keeps the values compared
    // here identical to the `data-color` strings the template already rendered.
    function handleize(value) {
      return String(value)
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    // Gallery media is grouped by colour. Anything carrying a colour tag is
    // revealed only while that colour is the active choice; media left untagged
    // (data-color="") counts as shared and stays on screen for all of them.
    function syncGalleryColor() {
      const input = document.querySelector(
        '[data-soften-option-name="Color"]:checked, [data-soften-option-name="Colour"]:checked'
      );
      if (!input) return;

      const activeColor = handleize(input.value);
      document.querySelectorAll('[data-soften-gallery]').forEach((gallery) => {
        gallery.setAttribute('data-active-color', activeColor);
        gallery
          .querySelectorAll('.soften-gallery__slide[data-color], [data-soften-gallery-thumb][data-color]')
          .forEach((el) => {
            const color = el.getAttribute('data-color');
            el.hidden = Boolean(color) && color !== activeColor;
          });
      });
    }

    function syncGallery(variant) {
      syncGalleryColor();

      const media = variant && variant.featured_media;
      if (!media) return;

      const mediaId = String(media.id);
      const galleries = document.querySelectorAll('[data-soften-gallery]');
      galleries.forEach((gallery) => {
        const track = gallery.querySelector('[data-soften-gallery-track]');
        const targetSlide = gallery.querySelector(`.soften-gallery__slide[data-media-id="${mediaId}"]`);
        if (!targetSlide) return;

        const slides = Array.from(gallery.querySelectorAll('.soften-gallery__slide'));
        const thumbs = gallery.querySelectorAll('[data-soften-gallery-thumb]');
        const targetIdx = slides.indexOf(targetSlide);

        slides.forEach((slide) => {
          slide.setAttribute('data-active', slide === targetSlide ? 'true' : 'false');
        });
        thumbs.forEach((thumb) => {
          thumb.setAttribute(
            'aria-current',
            thumb.getAttribute('data-media-id') === mediaId ? 'true' : 'false'
          );
        });

        if (track && targetIdx >= 0) {
          track.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
        }
      });
    }

    function syncStickyBar(variant) {
      const sticky = document.querySelector('[data-soften-sticky]');
      if (!sticky) return;

      const priceEl = sticky.querySelector('[data-soften-sticky-price]');
      const compareEl = sticky.querySelector('[data-soften-sticky-compare]');
      const ctaPriceEl = sticky.querySelector('[data-soften-sticky-cta-price]');

      if (priceEl) priceEl.innerHTML = formatMoney(variant.price);
      if (ctaPriceEl) ctaPriceEl.innerHTML = formatMoney(variant.price);

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      const thumbEl = sticky.querySelector('[data-soften-sticky-thumb] img');
      const featuredImage = variant.featured_image && variant.featured_image.src;
      if (thumbEl && featuredImage) {
        // A `width` query param on a Shopify CDN URL asks for a resized copy,
        // so the thumbnail pulls a small file instead of the full-size original.
        const sep = featuredImage.includes('?') ? '&' : '?';
        thumbEl.src = `${featuredImage}${sep}width=200`;
        if (variant.featured_image.alt) thumbEl.alt = variant.featured_image.alt;
      }
    }

    // syncUrl is set only once a shopper has genuinely chosen an option. The
    // first call fires while the page is still loading, and touching the
    // address bar at that moment reads to the theme editor as the preview
    // navigating itself off the page it asked for — it reports a redirect to
    // an unsupported URL and disables Save across every product page.
    function update(syncUrl) {
      const variant = findVariant();
      if (!variant) return;

      const variantInput = form.querySelector('[name="id"]');
      if (variantInput) variantInput.value = variant.id;

      const priceEl = root.querySelector('[data-soften-price]');
      const compareEl = root.querySelector('[data-soften-compare-price]');
      const saveEl = root.querySelector('[data-soften-save]');
      const ctaPriceEl = form.querySelector('[data-soften-cta-price]');

      if (priceEl) priceEl.innerHTML = formatMoney(variant.price);
      if (ctaPriceEl) ctaPriceEl.innerHTML = formatMoney(variant.price);

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
          if (saveEl) {
            const saved = variant.compare_at_price - variant.price;
            saveEl.innerHTML = 'Save ' + formatMoney(saved);
            saveEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }

      const installmentsEl = root.querySelector('[data-soften-installments]');
      if (installmentsEl) {
        installmentsEl.innerHTML = formatMoney(Math.round(variant.price / 4));
      }

      const cta = form.querySelector('[data-soften-cta]');
      if (cta) {
        if (variant.available) {
          cta.removeAttribute('disabled');
          const label = cta.querySelector('[data-soften-cta-label]');
          if (label) label.textContent = cta.getAttribute('data-label-default') || 'Add to cart';
        } else {
          cta.setAttribute('disabled', 'disabled');
          const label = cta.querySelector('[data-soften-cta-label]');
          if (label) label.textContent = cta.getAttribute('data-label-soldout') || 'Sold out';
        }
      }

      // Echo the chosen value beside its fieldset legend, so a legend reading
      // "Color" becomes "Color: Sand" once a swatch is picked.
      const optionInputs = form.querySelectorAll('[data-soften-option]:checked');
      optionInputs.forEach((input) => {
        const pos = input.getAttribute('data-soften-option');
        const display = root.querySelector(`[data-soften-option-display-${pos}]`);
        if (display) display.textContent = input.value;
      });

      syncGallery(variant);
      syncStickyBar(variant);

      // Leave the URL alone in the theme editor. The editor controls the
      // preview's location itself and reads any change we make as a redirect
      // out from under it. Horizon's stock variant picker skips the rewrite
      // under the same condition.
      if (!syncUrl || (window.Shopify && window.Shopify.designMode)) return;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      if (url.href !== window.location.href) {
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', (e) => {
      if (e.target && e.target.matches('[data-soften-option]')) {
        update(true);
      }
    });

    update(false);
  }

  /* ---------------------------------------------------------------
   * Sticky buy bar: show when hero ATC scrolls out of view
   * ------------------------------------------------------------- */
  function initStickyBar() {
    const sticky = document.querySelector('[data-soften-sticky]');
    const heroAtc = document.querySelector('[data-soften-hero-atc]');
    if (!sticky || !heroAtc) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          sticky.setAttribute('data-visible', entry.isIntersecting ? 'false' : 'true');
        });
      },
      { rootMargin: '0px 0px -50px 0px', threshold: 0 }
    );
    observer.observe(heroAtc);

    const stickyCta = sticky.querySelector('[data-soften-sticky-cta]');
    if (stickyCta) {
      stickyCta.addEventListener('click', (e) => {
        e.preventDefault();
        const form = document.querySelector('[data-soften-form]');
        if (form) {
          form.requestSubmit
            ? form.requestSubmit()
            : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
    }
  }

  /* ---------------------------------------------------------------
   * Section nav: highlight current section + smooth scroll
   * ------------------------------------------------------------- */
  function initSectionNav() {
    const nav = document.querySelector('[data-soften-section-nav]');
    if (!nav) return;
    const links = nav.querySelectorAll('a[href^="#"]');

    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        const targetId = link.getAttribute('href').slice(1);
        const target = document.getElementById(targetId);
        if (target) {
          e.preventDefault();
          const offset = 80;
          const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    const sections = Array.from(links)
      .map((link) => document.getElementById(link.getAttribute('href').slice(1)))
      .filter(Boolean);

    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            links.forEach((l) => l.setAttribute('aria-current', 'false'));
            const match = nav.querySelector(`a[href="#${entry.target.id}"]`);
            if (match) match.setAttribute('aria-current', 'true');
          }
        });
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );
    sections.forEach((s) => observer.observe(s));
  }

  /* ---------------------------------------------------------------
   * Fabric grid tile click -> sync with Color variant picker
   * ------------------------------------------------------------- */
  function initFabricSync() {
    const tiles = document.querySelectorAll('[data-soften-fabric-tile]');
    tiles.forEach((tile) => {
      tile.addEventListener('click', (e) => {
        const value = tile.getAttribute('data-value');
        const targetInput = document.querySelector(
          `[data-soften-option-name="${tile.getAttribute('data-option-name')}"][value="${CSS.escape(value)}"]`
        );
        if (targetInput) {
          e.preventDefault();
          targetInput.checked = true;
          targetInput.dispatchEvent(new Event('change', { bubbles: true }));
          targetInput.focus({ preventScroll: true });
          targetInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  }

  /* ---------------------------------------------------------------
   * Add-to-cart interceptor, following Horizon's standard-events contract
   *
   * Step by step:
   *   1. Catch the form submit, lock the button, and slide the drawer open
   *      straight away so the shopper gets feedback before any network
   *      work starts. The drawer is still showing the old cart here.
   *   2. Fire `shopify:cart:lines-update` with action="add" and a deferred
   *      promise attached, and do it BEFORE the request goes out.
   *      Horizon's cart-items-component, cart-drawer-component and
   *      cart-icon all listen for this, so by the time the response lands
   *      they are already holding the promise and waiting on it.
   *   3. POST /cart/add.js asking for bundled section rendering
   *      (`sections=cart-drawer-section`), which keeps the whole thing to
   *      one round-trip: the reply brings back the cart object and the
   *      rendered section markup together.
   *   4. Settle the promise with `{cart, detail: {sections, items,
   *      itemCount, didError}}` and let Horizon take it from there. It
   *      morphs the new cart-drawer-section into the live DOM rather than
   *      overwriting innerHTML, which is what keeps the dialog, its sticky
   *      state and any custom elements alive; it refreshes the cart icon
   *      bubble and mirrors the count into sessionStorage so a bfcache
   *      restore shows the right number; and it re-measures the drawer's
   *      sticky summary to keep the checkout button and grid aligned.
   *
   * Background reading:
   *   https://shopify.dev/docs/storefronts/themes/best-practices/standard-events
   *   https://shopify.dev/docs/api/ajax/reference/cart  (bundled sections)
   * ------------------------------------------------------------- */
  function initAddToCartDrawer() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const CART_LINES_UPDATE = 'shopify:cart:lines-update';

    function setButtonState(form, label) {
      const btn = form.querySelector('[data-soften-cta]') || form.querySelector('[type="submit"]');
      if (!btn) return () => {};
      const labelEl = btn.querySelector('[data-soften-cta-label]');
      const original = labelEl ? labelEl.textContent : null;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (labelEl && label) labelEl.textContent = label;
      let restored = false;
      return () => {
        if (restored) return;
        restored = true;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (labelEl && original !== null) labelEl.textContent = original;
      };
    }

    function openCartDrawer() {
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
        return true;
      }
      return false;
    }

    function makeDeferred() {
      let resolve;
      let reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      // Absorb unhandled rejections here. A failed add should not surface as
      // a page-level error just because some listener skipped its `.catch()`.
      promise.catch(() => {});
      return { promise, resolve, reject };
    }

    /**
     * Send the standard `shopify:cart:lines-update` event, shaped the way
     * Horizon's cart components read it. Those components reach for
     * `event.action`, `event.context`, `event.lines` and `event.promise`
     * at the top level rather than under `event.detail`, so the payload is
     * hung directly off a plain Event as own properties. It goes out on
     * `document` deliberately: `cart-items-component` bails early when
     * `event.target === this`, and dispatching higher up keeps that guard
     * from swallowing the update.
     */
    function dispatchCartLinesUpdate(action, lines, deferred) {
      const ev = new Event(CART_LINES_UPDATE, { bubbles: true, cancelable: true });
      ev.action = action;
      ev.context = 'product';
      ev.lines = lines;
      ev.promise = deferred.promise;
      document.dispatchEvent(ev);
    }

    function bindForm(form) {
      if (!form || form.dataset.softenAtcBound === '1') return;
      form.dataset.softenAtcBound = '1';

      form.addEventListener('submit', async (e) => {
        // No drawer on this storefront — the merchant chose cart_type=page,
        // or the component was stripped out — so step aside and let the
        // browser submit the form the ordinary way.
        if (!document.querySelector('cart-drawer-component')) return;

        e.preventDefault();
        const restoreButton = setButtonState(form, 'Adding…');

        const formData = new FormData(form);
        const variantId = String(formData.get('id') || '');
        const quantity = Number(formData.get('quantity') || 1) || 1;

        // Open the drawer right now so the interaction feels immediate. What
        // it shows at this instant is the cart as it was; Horizon's morph
        // replaces that with the updated contents once the promise below
        // resolves.
        openCartDrawer();

        // The deferred has to exist before the fetch begins, so every cart
        // subscriber — cart-items-component, cart-icon, cart-drawer-component
        // — has attached its `.then()` by the time a response can arrive.
        const deferred = makeDeferred();
        dispatchCartLinesUpdate(
          'add',
          [{ merchandiseId: variantId, quantity }],
          deferred
        );

        try {
          // Bundled Section Rendering: have Shopify render the cart drawer
          // section into the same /cart/add.js response. `sections_url` is
          // left unset on purpose — Shopify then falls back to the Referer
          // and renders in cart context, which is cheaper than making it
          // re-render the whole product page just to produce the drawer.
          formData.set('sections', 'cart-drawer-section');

          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });
          const data = await res.json().catch(() => ({}));

          if (!res.ok || data.status) {
            const msg = data.description || data.message || 'Could not add to cart.';
            deferred.reject(new Error(msg));
            window.alert(msg);
            return;
          }

          // Free Gift With Purchase hook
          //
          // When the variant that just went in is one of the trigger products
          // configured in soften-free-gift.js, that module fires its own
          // /cart/add.js for the gift line and hands the response back to us.
          // That response carries section HTML rendered after both lines were
          // in the cart, so using it here is what makes the gift show up on
          // the very first add rather than a beat later. The hook returns
          // null whenever no gift is due — it is already in the cart, the
          // shopper declined it, or this simply is not a trigger product —
          // and we keep our original response in that case.
          let finalData = data;
          try {
            if (variantId && window.softenFreeGift && typeof window.softenFreeGift.maybeAddGiftAfter === 'function') {
              const giftData = await window.softenFreeGift.maybeAddGiftAfter([variantId]);
              if (giftData) finalData = giftData;
            }
          } catch (giftErr) {
            console.warn('[soften] free-gift hook failed', giftErr);
          }

          // Resolving hands control back to Horizon: cart-items-component
          // morphs in the new section, cart-icon refreshes the bubble and
          // its sessionStorage copy of the count, and cart-drawer-component
          // re-measures its sticky state.
          deferred.resolve({
            cart: { totalQuantity: Number(finalData.item_count) || 0 },
            detail: {
              sections: finalData.sections || {},
              items: finalData.items,
              itemCount: Number(finalData.item_count) || 0,
              source: 'soften-pdp-form',
              didError: false,
            },
          });
        } catch (err) {
          console.error('[soften] add-to-cart failed', err);
          deferred.reject(err);
          window.alert('Sorry, something went wrong adding this item to your cart.');
        } finally {
          restoreButton();
        }
      });
    }

    document.querySelectorAll('[data-soften-form]').forEach(bindForm);
  }

  /* ---------------------------------------------------------------
   * Cart drawer backdrop click-to-close
   *
   * The dimmed backdrop behind the drawer is drawn as a `::before` on
   * `.page-wrapper` (see soften.css). A pseudo-element is not an event
   * target of its own, so a click landing on it is reported against the
   * host element — `event.target === pageWrapper`. That equality is our
   * signal that the shopper clicked outside the drawer panel, and we close
   * the drawer on it, which is how a native `showModal()` dialog behaves.
   * ------------------------------------------------------------- */
  function initCartDrawerBackdropClose() {
    const pageWrapper = document.querySelector('.page-wrapper');
    if (!pageWrapper) return;

    pageWrapper.addEventListener('click', (e) => {
      if (e.target !== pageWrapper) return;
      const drawer = document.querySelector('theme-drawer#cart-drawer[open]');
      if (drawer && typeof drawer.close === 'function') {
        drawer.close();
      }
    });
  }

  /* ---------------------------------------------------------------
   * Init
   * ------------------------------------------------------------- */
  ready(() => {
    document.querySelectorAll('[data-soften-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-soften-form]').forEach(initVariantForm);
    initStickyBar();
    initSectionNav();
    initFabricSync();
    initAddToCartDrawer();
    initCartDrawerBackdropClose();
  });
})();
document.addEventListener('change', function () {
  setTimeout(function () {
    if (window.bucksCC && window.bucksCC.reConvert) window.bucksCC.reConvert();
  }, 50);
});